import React, { FunctionComponent, useState, useEffect } from 'react'
import _map from 'lodash/map'
import _isEmpty from 'lodash/isEmpty'

import Table, { TableContent } from '../../../Table'
import {
  RecentSales,
  RecentSalesStore,
} from '../../../../typings/stores/RecentSalesStore'

import styles from './styles.module.css'

interface RecentSalesProps {
  recentSales?: RecentSalesStore
}

const tableFormatter = (recentSalesData: RecentSales[]): TableContent[] => {
  let data: TableContent[] = []
  if (!_isEmpty(recentSalesData)) {
    data = _map(recentSalesData, r => {
      return {
        cols: [
          {
            text: r.period,
          },
          {
            text: !_isEmpty(r.advertisers)
              ? r.advertisers
              : 'No advertisers for this period',
          },
        ],
      }
    })
  }

  return data
}

const RecentSalesList: FunctionComponent<RecentSalesProps> = ({
  recentSales,
}) => {
  const [componentRecentSales, setComponentRecentSales] = useState([])

  useEffect(() => {
    setComponentRecentSales(recentSales.data)
  }, [recentSales])

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>Most Recent Sales Reported by Advertiser</h2>
      <Table
        data-rv="rr-table"
        className={styles.table}
        headers={[
          {
            text: 'Period',
          },
          {
            text: 'Advertisers',
          },
        ]}
        content={tableFormatter(componentRecentSales)}
        status={recentSales.status}
        error={recentSales.error}
      />
    </div>
  )
}

export default RecentSalesList
